import React, { Component } from 'react'
import { Card, Form, Input, InputNumber, Button, Select, Table, Tag, Popconfirm, Modal, message, Pagination } from 'antd'
import {
    getCommonSqlPageList,
    getCommonSqlDetail,
    saveCommonSql,
    updateCommonSql,
    updateCommonSqlStatus,
    deleteCommonSql
} from '../../../request'

const { TextArea } = Input

const columnsKey = {
    id: 'ID',
    sqlName: 'SQL名称',
    dbName: '数据库',
    resultLimit: '返回上限',
    status: '状态',
    updatedBy: '更新人',
    updatedAt: '更新时间',
    operation: '操作'
}

const editLayout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 18 }
}

export default class CommonSql extends Component {
    searchFormRef = React.createRef()
    editFormRef = React.createRef()

    state = {
        loading: false,
        submitLoading: false,
        dataSource: [],
        total: 0,
        columns: [],
        queryParam: {
            currentPage: 1,
            pageSize: 20,
            sqlName: null,
            dbName: null,
            status: null
        },
        editVisible: false,
        editingId: null
    }

    componentDidMount() {
        this.createColumns(columnsKey)
        this.loadList()
    }

    createColumns = (createKeys) => {
        const columns = Object.keys(createKeys).map((item) => {
            const initObj = {
                title: createKeys[item],
                dataIndex: item,
                key: item,
                align: 'center'
            }
            if (item === 'status') {
                return {
                    ...initObj,
                    width: 100,
                    render: (text) => <Tag color={text === 1 ? 'green' : 'red'}>{text === 1 ? '启用' : '禁用'}</Tag>
                }
            }
            if (item === 'operation') {
                return {
                    ...initObj,
                    width: 300,
                    fixed: 'right',
                    render: (_, record) => (
                        <>
                            <Button type="link" size="small" onClick={() => this.openEdit(record.id)}>编辑</Button>
                            <Popconfirm
                                title={`确定${record.status === 1 ? '禁用' : '启用'}该SQL吗？`}
                                onConfirm={() => this.changeStatus(record)}
                                okText="确认"
                                cancelText="取消"
                            >
                                <Button type="link" size="small">{record.status === 1 ? '禁用' : '启用'}</Button>
                            </Popconfirm>
                            <Popconfirm
                                title="确定删除该SQL吗？"
                                onConfirm={() => this.handleDelete(record.id)}
                                okText="确认"
                                cancelText="取消"
                            >
                                <Button type="link" size="small" danger>删除</Button>
                            </Popconfirm>
                        </>
                    )
                }
            }
            return initObj
        })
        this.setState({ columns })
    }

    loadList = () => {
        this.setState({ loading: true })
        getCommonSqlPageList(this.state.queryParam).then((res) => {
            this.setState({
                dataSource: res.list || [],
                total: res.total || 0
            })
        }).finally(() => {
            this.setState({ loading: false })
        })
    }

    onSearch = (values) => {
        const nextParam = {
            ...this.state.queryParam,
            currentPage: 1,
            sqlName: values.sqlName || null,
            dbName: values.dbName || null,
            status: values.status === undefined ? null : values.status
        }
        this.setState({ queryParam: nextParam }, this.loadList)
    }

    onResetSearch = () => {
        this.searchFormRef.current && this.searchFormRef.current.resetFields()
        this.setState({
            queryParam: {
                ...this.state.queryParam,
                currentPage: 1,
                sqlName: null,
                dbName: null,
                status: null
            }
        }, this.loadList)
    }

    openCreate = () => {
        this.setState({
            editVisible: true,
            editingId: null
        }, () => {
            this.editFormRef.current && this.editFormRef.current.setFieldsValue({
                resultLimit: 1000,
                status: 1
            })
        })
    }

    openEdit = (id) => {
        this.setState({
            submitLoading: true,
            editVisible: true,
            editingId: id
        }, () => {
            this.editFormRef.current && this.editFormRef.current.resetFields()
            getCommonSqlDetail({ id }).then((res) => {
                setTimeout(() => {
                    this.editFormRef.current && this.editFormRef.current.setFieldsValue({
                        id: res.id,
                        sqlName: res.sqlName,
                        dbName: res.dbName,
                        sqlTemplate: res.sqlTemplate,
                        paramSchema: res.paramSchema,
                        resultLimit: res.resultLimit,
                        status: res.status,
                        remark: res.remark
                    })
                }, 0)
            }).finally(() => {
                this.setState({ submitLoading: false })
            })
        })
    }

    closeEdit = () => {
        this.setState({
            editVisible: false,
            editingId: null
        })
        this.editFormRef.current && this.editFormRef.current.resetFields()
    }

    submitEdit = (values) => {
        this.setState({ submitLoading: true })
        const request = this.state.editingId ? updateCommonSql : saveCommonSql
        request(values).then(() => {
            message.success(this.state.editingId ? '更新成功' : '保存成功')
            this.closeEdit()
            this.loadList()
        }).finally(() => {
            this.setState({ submitLoading: false })
        })
    }

    changeStatus = (record) => {
        updateCommonSqlStatus({
            id: record.id,
            status: record.status === 1 ? 0 : 1
        }).then(() => {
            message.success('状态更新成功')
            this.loadList()
        })
    }

    handleDelete = (id) => {
        deleteCommonSql({ id }).then(() => {
            message.success('删除成功')
            this.loadList()
        })
    }

    onPageChange = (currentPage, pageSize) => {
        this.setState({
            queryParam: {
                ...this.state.queryParam,
                currentPage,
                pageSize
            }
        }, this.loadList)
    }

    render() {
        const { dataSource, columns, loading, total, queryParam, editVisible, submitLoading, editingId } = this.state
        return (
            <div>
                <Card title="常用SQL管理" bordered={false}>
                    <Form
                        layout="inline"
                        ref={this.searchFormRef}
                        onFinish={this.onSearch}
                    >
                        <Form.Item name="sqlName">
                            <Input placeholder="SQL名称" allowClear />
                        </Form.Item>
                        <Form.Item name="dbName">
                            <Input placeholder="数据库名" allowClear />
                        </Form.Item>
                        <Form.Item name="status">
                            <Select
                                style={{ width: 120 }}
                                allowClear
                                placeholder="状态"
                                options={[
                                    { label: '启用', value: 1 },
                                    { label: '禁用', value: 0 }
                                ]}
                            />
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">查询</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button onClick={this.onResetSearch}>重置</Button>
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" danger onClick={this.openCreate}>新增</Button>
                        </Form.Item>
                    </Form>

                    <Table
                        style={{ marginTop: 16 }}
                        bordered
                        size="small"
                        pagination={false}
                        rowKey="id"
                        dataSource={dataSource}
                        columns={columns}
                        loading={loading}
                        scroll={{ x: 1200 }}
                    />

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 16 }}>
                        <Pagination
                            size="small"
                            hideOnSinglePage
                            current={queryParam.currentPage}
                            pageSize={queryParam.pageSize}
                            total={total}
                            showSizeChanger
                            onChange={this.onPageChange}
                        />
                    </div>
                </Card>

                <Modal
                    title={editingId ? '编辑SQL' : '新增SQL'}
                    open={editVisible}
                    onCancel={this.closeEdit}
                    onOk={() => this.editFormRef.current && this.editFormRef.current.submit()}
                    confirmLoading={submitLoading}
                    width={900}
                    destroyOnClose={false}
                >
                    <Form
                        {...editLayout}
                        ref={this.editFormRef}
                        onFinish={this.submitEdit}
                        initialValues={{ resultLimit: 1000, status: 1 }}
                    >
                        <Form.Item name="id" hidden>
                            <Input />
                        </Form.Item>
                        <Form.Item
                            label="SQL名称"
                            name="sqlName"
                            rules={[{ required: true, message: '请输入SQL名称' }]}
                        >
                            <Input maxLength={128} />
                        </Form.Item>
                        <Form.Item
                            label="数据库名"
                            name="dbName"
                            rules={[
                                { required: true, message: '请输入数据库名' },
                                { pattern: /^[a-zA-Z0-9_-]+$/, message: '仅支持字母数字下划线和中划线' }
                            ]}
                        >
                            <Input maxLength={64} />
                        </Form.Item>
                        <Form.Item
                            label="SQL模板"
                            name="sqlTemplate"
                            rules={[{ required: true, message: '请输入SQL模板' }]}
                        >
                            <TextArea rows={8} placeholder="仅支持查询SQL，参数请使用#{paramName}占位" />
                        </Form.Item>
                        <Form.Item
                            label="参数Schema"
                            name="paramSchema"
                            extra='示例：[{"name":"startDate","type":"string","required":true}]'
                        >
                            <TextArea rows={3} />
                        </Form.Item>
                        <Form.Item
                            label="返回上限"
                            name="resultLimit"
                            rules={[{ required: true, message: '请输入返回上限' }]}
                        >
                            <InputNumber min={1} max={10000} style={{ width: '100%' }} />
                        </Form.Item>
                        <Form.Item
                            label="状态"
                            name="status"
                            rules={[{ required: true, message: '请选择状态' }]}
                        >
                            <Select
                                options={[
                                    { label: '启用', value: 1 },
                                    { label: '禁用', value: 0 }
                                ]}
                            />
                        </Form.Item>
                        <Form.Item label="备注" name="remark">
                            <TextArea rows={2} maxLength={500} />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}
